var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-center position-ref"},[_c('div',{staticClass:"content",staticStyle:{"text-align":"center"}},[_c('br'),_c('br'),_c('img',{attrs:{"src":"https://storage.googleapis.com/ueslmscom/uploads/default/ues-logo-new.svg","width":"200"}}),_c('br'),_c('h3',{staticStyle:{"margin-top":"100px","color":"#712481"}},[_vm._v("service.ueslms.com")])])])
}]

export { render, staticRenderFns }